export default __webpack_public_path__ + "static/media/tg.b472aff0.svg";